;(function (Scroll, $, undefined) {

  const $body = document.querySelector('body');
  let scrollPosition = 0;

  const getHeaderHeight = () => { 
    let bannerHeight = $('.banner-is-shown').innerHeight();
    let emailPushdown = $('.email-pushdown.is-active').innerHeight();
    let navHeaderHeight = $('header').outerHeight();
    let heightFromTop = bannerHeight + emailPushdown + navHeaderHeight;

    return heightFromTop + 30;
  }
  
  var bindUIActions = function () {
    $('[scroll-to]').on('click', function (event) {
      event.preventDefault();
      var scrollOffset = 0;
      var scrollTargetName = $(this).attr('scroll-to');
      if(scrollTargetName != 'top') {
        var $scrollTarget = $('[scroll-position="' + scrollTargetName + '"]');
        scrollOffset = $scrollTarget.offset().top - getHeaderHeight();

      }

      $('html, body').animate({ scrollTop: scrollOffset}, 500);
    });
  };

  Scroll.lock = function () {
    scrollPosition = window.pageYOffset;
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
  };

  Scroll.unlock = function () {
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
  };

  Scroll.init = function () {
    bindUIActions();
  };

}(window.Scroll = window.Scroll || {}, jQuery));
